import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignaturePad = ({ onSave, label = "Signature" }) => {
  const sigPad = useRef(null);
  const [isSigned, setIsSigned] = useState(false);

  const clear = () => {
    sigPad.current.clear();
    setIsSigned(false);
  };

  const save = () => {
    if (sigPad.current.isEmpty()) {
      alert('Please provide a signature first');
      return;
    }
    
    // Get signature as base64 image
    const signatureData = sigPad.current.toDataURL('image/png');
    setIsSigned(true);
    onSave(signatureData);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label} *</label>
      <div className="border-2 border-gray-300 rounded-lg bg-white">
        <SignatureCanvas
          ref={sigPad}
          canvasProps={{
            className: 'w-full h-40',
            style: { touchAction: 'none' }
          }}
          onEnd={() => setIsSigned(false)}
        />
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={clear}
          className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          Clear
        </button>
        <button
          type="button"
          onClick={save}
          className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Save Signature
        </button>
        {isSigned && (
          <span className="text-sm text-green-600 flex items-center">
            ✓ Signature saved
          </span>
        )}
      </div>
      <p className="text-xs text-gray-500">Sign with your finger or mouse</p>
    </div>
  );
};

export default SignaturePad;
